module.exports = __webpack_public_path__ + "static/media/prop-10.9ab55c1c.webp";